import React from "react"

class Countdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    console.log(this.props);
  }
  getInitialState() {
    let state;
    state = {
      seconds: this.props.seconds
    };
    return state
  }

  componentDidMount() {
    setInterval(() => {
      if (this.state.seconds > 0) {
        this.setState({seconds: this.state.seconds - 1});
      } else if(this.state.seconds == 0) {
	this.setState({seconds: this.state.seconds - 1});
        window.location.href = `/dashboard/subscriptions/${this.props.subscription.id}/tests/${this.props.test.id}/finish`
      }
    }, 1000);
  }

  render () {
    let date = new Date(null);
    date.setSeconds(this.state.seconds);
    let timeString = date.toISOString().substr(11, 8);
    return (
      <React.Fragment>
        <p>
          <strong>Block Time Remaining: {timeString}</strong>
        </p>
      </React.Fragment>
    );
  }
}

export default Countdown



// WEBPACK FOOTER //
// app/javascript/components/Countdown.js